import { useEffect, useState } from "react";
import { ProductFruits } from "react-product-fruits";
import { useSessionStore } from "../../store/session-store";

function ProductFruitsManager() {
  const [userInfo, setUserInfo] = useState(null);
  const { sessionDetails } = useSessionStore();

  useEffect(() => {
    const info = {};
    const email = sessionDetails?.email;
    const userId = sessionDetails?.id;

    if (email) {
      info["username"] = email;
    } else {
      info["username"] = userId;
    }
    setUserInfo(info);
  }, []);

  return (
    <>
      {userInfo && (
        <ProductFruits
          workspaceCode="qbvVftNewG44kFFz"
          language="en"
          user={userInfo}
        />
      )}
    </>
  );
}

export { ProductFruitsManager };
